import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../../../app/guards'
import { EditStockTransferPage } from '../../../../features/inventory/stock-transfer-pages'

export const Route = createFileRoute('/_app/stock-transfers/$transferId/edit')({
  staticData: { crumb: 'stockTransferEdit' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'inventory.transfer'),
  component: EditStockTransferPage,
})
